import { render, staticRenderFns } from "./orderDetailBtn.vue?vue&type=template&id=76ce1106&scoped=true&"
import script from "./orderDetailBtn.vue?vue&type=script&lang=js&"
export * from "./orderDetailBtn.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailBtn.vue?vue&type=style&index=0&id=76ce1106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce1106",
  null
  
)

export default component.exports